import { ERROR_ACTION, WAIT_FOR_ACTION } from "redux-wait-for-action";

export const actionTypes = {
    AUDIT_REVIEW_ALT_ASSETS_FILTER_SET: "AUDIT_REVIEW_ALT_ASSETS_FILTER_SET",
    AUDIT_REVIEW_ALT_ASSETS_SUMMARY_SET: "AUDIT_REVIEW_ALT_ASSETS_SUMMARY_SET",

    AUDIT_REVIEW_AUDIT_ASSETS_FILTER_SET:
        "AUDIT_REVIEW_AUDIT_ASSETS_FILTER_SET",
    AUDIT_REVIEW_AUDIT_ASSETS_SUMMARY_SET:
        "AUDIT_REVIEW_AUDIT_ASSETS_SUMMARY_SET",

    AUDIT_REVIEW_VALIDATED_VISIBILITY_ASSETS_FILTER_SET:
        "AUDIT_REVIEW_VALIDATED_VISIBILITY_ASSETS_FILTER_SET",
    AUDIT_REVIEW_VALIDATED_VISIBILITY_ASSETS_SUMMARY_SET:
        "AUDIT_REVIEW_VALIDATED_VISIBILITY_ASSETS_SUMMARY_SET",

    AUDIT_REVIEW_COMPLETION_SET: "AUDIT_REVIEW_COMPLETION_SET",

    AUDIT_REVIEW_GET_FAILURE: "AUDIT_REVIEW_GET_FAILURE",
    AUDIT_REVIEW_GET_REQUEST: "AUDIT_REVIEW_GET_REQUEST",
    AUDIT_REVIEW_GET_SUCCESS: "AUDIT_REVIEW_GET_SUCCESS",

    AUDIT_REVIEW_INIT: "AUDIT_REVIEW_INIT",

    AUDIT_REVIEW_STATUS_SET: "AUDIT_REVIEW_STATUS_SET"
};

export const actionCreators = {
    altAssetsFilterSet: (filter: any, status: string) => ({
        type: actionTypes.AUDIT_REVIEW_ALT_ASSETS_FILTER_SET,
        payload: { filter, status }
    }),
    altAssetsSummarySet: (summary: any) => ({
        type: actionTypes.AUDIT_REVIEW_ALT_ASSETS_SUMMARY_SET,
        payload: { summary }
    }),

    auditAssetsFilterSet: (filter: any, status: string) => ({
        type: actionTypes.AUDIT_REVIEW_AUDIT_ASSETS_FILTER_SET,
        payload: { filter, status }
    }),
    auditAssetsSummarySet: (summary: any) => ({
        type: actionTypes.AUDIT_REVIEW_AUDIT_ASSETS_SUMMARY_SET,
        payload: { summary }
    }),

    validatedVisibilityFilterSet: (filter: any, status: string) => ({
        type: actionTypes.AUDIT_REVIEW_VALIDATED_VISIBILITY_ASSETS_FILTER_SET,
        payload: { filter, status }
    }),
    validatedVisibilitySummarySet: (summary: any) => ({
        type: actionTypes.AUDIT_REVIEW_VALIDATED_VISIBILITY_ASSETS_SUMMARY_SET,
        payload: { summary }
    }),

    completionSet: (isReviewComplete: boolean, isReissueNeeded: boolean) => ({
        type: actionTypes.AUDIT_REVIEW_COMPLETION_SET,
        payload: { isReissueNeeded, isReviewComplete }
    }),

    getRequest: (auditId: number) => ({
        type: actionTypes.AUDIT_REVIEW_GET_REQUEST,
        payload: { auditId },
        [WAIT_FOR_ACTION]: actionTypes.AUDIT_REVIEW_GET_SUCCESS,
        [ERROR_ACTION]: actionTypes.AUDIT_REVIEW_GET_FAILURE
    }),
    getSuccess: (auditReview: any) => ({
        type: actionTypes.AUDIT_REVIEW_GET_SUCCESS,
        payload: { auditReview }
    }),
    getFailure: (error) => ({
        type: actionTypes.AUDIT_REVIEW_GET_FAILURE,
        error
    }),

    init: () => ({
        type: actionTypes.AUDIT_REVIEW_INIT
    }),

    statusSet: (status: string) => ({
        type: actionTypes.AUDIT_REVIEW_STATUS_SET,
        payload: { status }
    })
};

export default {
    create: actionCreators,
    type: actionTypes
};
